import { marked } from "marked";
import DOMPurify from "isomorphic-dompurify";
import "./MarkdownComponent.css";

export default function MarkdownComponent({ markdownContent }) {
  marked.setOptions({ gfm: false });
  const html = marked.parse(markdownContent);
  // const convertedHtmlToJsx = convert(html); 
  const sanitizedHTML = DOMPurify.sanitize(html)

  return (
    <div id="markdown-body"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }} >
    </div>
  );
}